"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const document = (sdk) => {
    const { sdkConfig: { url } } = sdk;
    const httpClient = sdk.httpClient;
    return {
        convertHtmlToPdf: async (html) => {
            const endpoint = `${url}/v4/document/convert-html-to-pdf`;
            const result = await httpClient.post(endpoint, {
                payload: { html },
            });
            return result.data;
        },
        convertHtmlToPdfPublic: async (html, accessToken) => {
            const endpoint = `${url}/v4/document/convert-html-to-pdf-public`;
            const result = await httpClient.post(endpoint, {
                payload: { html, accessToken },
                auth: false,
            });
            return result.data;
        },
        convertHtmlToDocx: async (html) => {
            const endpoint = `${url}/v4/document/convert-html-to-docx`;
            const result = await httpClient.post(endpoint, {
                payload: { html },
            });
            return result.data;
        }
    };
};
exports.default = document;
